import React, { useState, useEffect } from "react";
// import { Animated } from "react-animated-css";
import "./Modal.css";
import rapperImageLoader from "../../../utils/helperFunctions.js";

function Modal(props) {
  const [cardClicked, setCardClicked] = useState("null");

  let handleCardClick = card => {
    setCardClicked(card);
    //hides modal after 2 seconds
    setTimeout(function () {
      props.handleHideModal(props.position, props[card]);
    }, 1800);
  };

  
  let handleKeyPress = (e) => {
    e = e || window.event;
    if (e.keyCode == '37') {
      handleCardClick('left');
    }
    else if (e.keyCode == '39') {
      handleCardClick('right');
    }
  }
  
  useEffect(()=>{
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    }
  })
  
  //adjust css and animations based on chosen card
  let chosen = () => {
    //check if the left card was clicked
    if (cardClicked === "left") {
      //we should add event listeners
      //element.addEventListener('animationend', function() { doSomething() })
      //get div's
      const element = document.querySelector("#left");
      const removedElement = document.querySelector("#right");
      const colorChangeGreen = document.querySelector("#colorChangeLeft");
      const colorChangeRed = document.querySelector("#colorChangeRight");
      const vs = document.querySelector(".vs");
      //update animations
      element.classList.remove("animated", "fadeInDown");
      element.classList.add("animated", "flash");
      removedElement.classList.remove("animated", "fadeInDown");
      removedElement.classList.add("animated", "fadeOutDownBig");
      vs.classList.remove("animated", "flipInX");
      vs.classList.add("animated", "flipOutX");
      //change colors
      colorChangeGreen.style.backgroundColor = "#3CEE04";
      colorChangeRed.style.backgroundColor = "#E6000D";
      colorChangeRed.style.color = "#000";
      colorChangeGreen.style.color = "#000";
      setTimeout(function () {
        element.classList.remove("animated", "flash");
        element.classList.add("animated", "fadeOut");
      }, 1100);
      return "";
    }
    //Check if the right card was clicked
    else if (cardClicked === "right") {
      //get divs
      const element = document.querySelector("#right");
      const removedElement = document.querySelector("#left");
      const colorChangeGreen = document.querySelector("#colorChangeRight");
      const colorChangeRed = document.querySelector("#colorChangeLeft");
      const vs = document.querySelector(".vs");
      //update animations
      element.classList.remove("animated", "fadeInDown");
      element.classList.add("animated", "flash");
      removedElement.classList.remove("animated", "fadeInDown");
      removedElement.classList.add("animated", "fadeOutDownBig");
      vs.classList.remove("animated", "flipInX");
      vs.classList.add("animated", "flipOutX");
      //change colors
      colorChangeGreen.style.backgroundColor = "#3CEE04";
      colorChangeRed.style.backgroundColor = "#E6000D";
      colorChangeRed.style.color = "#000";
      colorChangeGreen.style.color = "#000";
      setTimeout(function () {
        element.classList.remove("animated", "flash");
        element.classList.add("animated", "fadeOut");
      }, 1100);
      return "";
    }
  };

  return (
    <div id="Modal" className="">
      {chosen()}
      <div className="modal_background " />
      <div className="modal_wrapper modal_animate_opacity">
        <div className="modal_content">
          <div className="modal_content_title animated fadeIn">PICK THE WINNER</div>
          <div className="left_bracket animated fadeInLeft"></div>
          <div
            className="card animated fadeInDown"
            onClick={() => handleCardClick("left")}
            id="left"
          >
            <div className="card_img"><img className="image_left" src={rapperImageLoader(props.left.pic)} alt="Rapper"></img></div>
            <div className="card_textwrap" id="colorChangeLeft">
              <div className="cardtext_name">{props.left.name}</div>
              <div className="cardtext_bio">{props.left.bio}</div>
              <div className="cardtext_hometown">{props.left.hometown}</div>
              {/* <div className="cardtext_subgenre">Region: {props.left.region}</div> */}
              {/* <div className="cardtext_subgenre">Decade: {props.left.decade}</div> */}
            </div>
          </div>
          <div className="vs_column">
            <div id="vs" className="vs animated flipInY">VS</div>
          </div>
          <div
            className="card animated fadeInDown"
            onClick={() => handleCardClick("right")}
            id="right"
          >
            <div className="card_img"><img className="image_right" src={rapperImageLoader(props.right.pic)} alt="Rapper"></img></div>
            <div className="card_textwrap" id="colorChangeRight">
              <div className="cardtext_name">{props.right.name}</div>
              <div className="cardtext_bio">{props.right.bio}</div>
              <div className="cardtext_hometown">{props.right.hometown}</div>
              {/* <div className="cardtext_subgenre">Region: {props.right.region}</div> */}
              {/* <div className="cardtext_subgenre">Decade: {props.right.decade}</div> */}
            </div>
          </div>
          <div className="right_bracket animated fadeInRight"></div>
        </div>
      </div>
    </div>
  );
}
export default Modal;
